var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dashboard',_vm._g({attrs:{"results-set":_vm.resultsSet,"context":_vm.context,"query-id":_vm.queryId,"query-configuration":_vm.queryConfiguration,"on-fire-query":_vm.onFireQuery}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }